"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollTop = void 0;
var react_1 = require("react");
var navigation_1 = require("next/navigation");
var useScrollTop = function () {
    var pathname = (0, navigation_1.usePathname)();
    (0, react_1.useEffect)(function () {
        var mainContentEl = document.querySelector('.mainContent');
        requestAnimationFrame(function () {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            if (mainContentEl)
                mainContentEl.scrollTop = 0;
        });
    }, [pathname]);
};
exports.useScrollTop = useScrollTop;
